import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUsers, faEye, faPlus, faMinus } from '@fortawesome/free-solid-svg-icons';
import Circles from '../../../assets/images/circle.png';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const StateLoginDashboard = ({ 
  loading, 
  stateCount,
  handleMoreInfoClick 
}) => {
  // Helper function for CSV export
  const getDistrictLabel = (item) =>
    item?.districtNames ?? item?.districtName ?? item?.DistrictName ?? 'N/A';

  const exportToCSV = (data, filename, headers) => {
    if (!data || data.length === 0) {
      alert("No data available to export.");
      return;
    }

    const csvRows = [headers.join(",")];

    data.forEach((item, index) => {
      const row = [index + 1];

      if (headers.includes("District Name") || headers.includes("District")) {
        row.push(`"${getDistrictLabel(item)}"`);
        row.push(`"${item.totalUsers || item.total || item.recordCount || 0}"`);
      } else if (headers.includes("Sub District Name")) {
        row.push(`"${item.blockName || item.subDistrictName || 'N/A'}"`);
        row.push(`"${item.recordCount || item.total || 0}"`);
      } else if (headers.includes("Surveyor Name")) {
        row.push(`"${item.surveyorName || item.userName || 'N/A'}"`);
        row.push(`"${item.mobileNo || item.mobile || 'N/A'}"`);
        row.push(`"${item.totalFarmers || item.total || 0}"`);
      } else if (headers.includes("User Type")) {
        row.push(`"${item.userTypeName || 'N/A'}"`);
        row.push(`"${item.totalUsers || item.total || 0}"`);
      } else if (headers.includes("Count") && headers.length === 2) {
        row.push(`"${item.total || 0}"`);
      } else {
        row.push(`"${item.stateName || item.userTypeName || 'N/A'}"`);
        row.push(`"${item.total || 0}"`);
      }

      csvRows.push(row.join(","));
    });

    const csvContent = csvRows.join("\n");
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `${filename}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  const navigate = useNavigate();
  // Check if current user is CRM component
  const userTypeCode = sessionStorage.getItem("userTypeCodeModel");
  const isCRMComponent = parseInt(userTypeCode) === 2;
  // Local state for State Admin specific data
  const [userCount, setUserCount] = useState(0);
  const [smamchcHistoryCount, setSmamchcHistoryCount] = useState(0);
  const [individualsmamCount, setIndividualSmamCount] = useState(0);
  const [individualcrmCount, setIndividualCrmCount] = useState(0);
  const [individualCrmSurveyDetails, setIndividualCrmSurveyDetails] = useState([]);
  const [expandedIndividualCrmIndex, setExpandedIndividualCrmIndex] = useState(-1);
  const [expandedIndividualCrmDistrictData, setExpandedIndividualCrmDistrictData] = useState([]);
  const [loadingIndividualCrmDistrict, setLoadingIndividualCrmDistrict] = useState(false);
  const [chcCount, setChcCount] = useState(0);
  const [apiDataReportCount, setApiDataReportCount] = useState(0);
  const [localLoading, setLocalLoading] = useState(false);
  const [stateDetails, setStateDetails] = useState([]);
  // Table visibility states
  const [activeTable, setActiveTable] = useState('none'); // 'none', 'smamChc', 'crmChc', 'users', 'apiDataReport'
  const [crmChcDetails, setCrmChcDetails] = useState([]);
  const [smamChcDetails, setSmamChcDetails] = useState([]);
  const [smamIndividualDetails, setSmamIndividualDetails] = useState([]);
  const [apiDataReportDetails, setApiDataReportDetails] = useState([]);
  const [selectedFinYear, setSelectedFinYear] = useState("");
  const [expandedCRMIndex, setExpandedCRMIndex] = useState(-1);
  const [crmChcDetailedData, setCrmChcDetailedData] = useState({});
  const [expandedSMAMIndex, setExpandedSMAMIndex] = useState(-1);
  const [smamChcDetailedData, setSmamChcDetailedData] = useState({});
  const [expandedApiDataReportIndex, setExpandedApiDataReportIndex] = useState(null);
  const [expandedApiDataReportDistrictData, setExpandedApiDataReportDistrictData] = useState([]);
  const [expandedApiDataReportDistrictIndex, setExpandedApiDataReportDistrictIndex] = useState(null);
  const [expandedApiDataReportDistrictDetailsData, setExpandedApiDataReportDistrictDetailsData] = useState([]);
  const [expandedApiDataReportSubDistrictIndex, setExpandedApiDataReportSubDistrictIndex] = useState(null);
  const [expandedApiDataReportSubDistrictDetailsData, setExpandedApiDataReportSubDistrictDetailsData] = useState([]);
  const [selectedImageUrl, setSelectedImageUrl] = useState(null);
  const [showImageModal, setShowImageModal] = useState(false);
  const [showImplementsModal, setShowImplementsModal] = useState(false);
  const [selectedImplements, setSelectedImplements] = useState(null);
  
  // States for Active Users drill-down
  const [expandedUserTypeIndex, setExpandedUserTypeIndex] = useState(-1);
  const [expandedStateIndex, setExpandedStateIndex] = useState(-1);
  const [expandedDistrictIndex, setExpandedDistrictIndex] = useState(-1);
  const [userTypeData, setUserTypeData] = useState([]);
  const [stateData, setStateData] = useState([]);
  const [districtData, setDistrictData] = useState([]);
  const [surveyorData, setSurveyorData] = useState([]);
  const [loadingFarmers, setLoadingFarmers] = useState({});
  const [isSurveyorExpanded, setIsSurveyorExpanded] = useState(false);
  const [farmerData, setFarmerData] = useState([]);
  const [districtDrillDownData, setDistrictDrillDownData] = useState({});
  const [selectedDistrict, setSelectedDistrict] = useState(null);
  const [selectedSurveyor, setSelectedSurveyor] = useState(null);
  const [surveyorFarmerData, setSurveyorFarmerData] = useState({});

  // State Admin API calls
  const fetchUserCount = async () => {
    try {
      const userRoleCode = sessionStorage.getItem("userRoleCodeModel");
      const stateCode = sessionStorage.getItem("stateNameModel");
      const userTypeCode = sessionStorage.getItem("userTypeCodeModel");
      
      console.log('fetchUserCount - State Admin API call');
      
      // Use dynamic userTypeCode from session storage
      let apiStateCode = parseInt(stateCode) || 0;
      
      const { data } = await axios.post(
        `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/GetStateDashboarCount`,
        {
          "flag": "AllUsers",
          "stateCode": apiStateCode,
          "userTypeCode": parseInt(userTypeCode)
        },
        {
          headers: {
            'accept': '*/*',
            'Content-Type': 'application/json'
          }
        }
      );
      
      let userCountValue = 0;
      if (data && data.success) {
        if (data.totalUsers !== undefined && data.totalUsers !== null) {
          userCountValue = parseInt(data.totalUsers.toString());
          console.log('State User Count from totalUsers:', userCountValue);
        } else if (data.dataContent && data.dataContent.length > 0) {
          const possible = data.dataContent[0];
          const totalVal = possible.totalUsers || possible.totalUsers || possible.count;
          userCountValue = parseInt(totalVal.toString()) || 0;
          console.log('State User Count from dataContent:', userCountValue);
        }
      }
      
      setUserCount(userCountValue);
    } catch (error) {
      console.error('Error fetching State User count:', error);
      setUserCount(0);
    }
  };

  const fetchSMAMCHCCount = async () => {
    try {
      const stateCode = sessionStorage.getItem("stateNameModel");
      
      console.log('fetchSMAMCHCCount - State Admin API call');
      console.log('Using stateCode:', stateCode);
      
      // Always use userTypeCode: 3 for SMAM CHC count as per API requirement
      const { data } = await axios.post(
        `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/GetDashboarSurveyorReportCountState`,
        {
          "flag": "CHCCount",
          "stateCode": parseInt(stateCode) || 0,
          "userTypeCode": 3  // Fixed value for SMAM CHC
        },
        {
          headers: {
            'accept': '*/*',
            'Content-Type': 'application/json'
          }
        }
      );
      
      console.log('SMAM CHC API Response:', data);
      
      if (data.success && data.dataContent && data.dataContent.length > 0) {
        // Extract total from dataContent array
        const smamChcCountValue = parseInt(data.dataContent[0].total) || 0;
        setSmamchcHistoryCount(smamChcCountValue);
        console.log('State SMAM CHC Count from total:', smamChcCountValue);
      } else {
        setSmamchcHistoryCount(0);
        console.log('No State SMAM CHC data received or invalid format:', data);
      }
    } catch (error) {
      console.error('Error fetching State SMAM CHC count:', error);
      setSmamchcHistoryCount(0);
    }
  };

  const fetchIndividualSMAMCCount = async () => {
    try {
      const stateCode = sessionStorage.getItem("stateNameModel");
      
      console.log('fetchIndividualSMAMCCount - State Admin API call');
      console.log('Using stateCode:', stateCode);
      
      // Always use userTypeCode: 3 for SMAM CHC count as per API requirement
      const { data } = await axios.post(
        `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/GetDashboarSurveyorReportCountState`,
        {
          "flag": "SMAM_Individual",
          "stateCode": parseInt(stateCode) || 0,
          "userTypeCode": 3  // Fixed value for SMAM CHC
        },
        {
          headers: {
            'accept': '*/*',
            'Content-Type': 'application/json'
          }
        }
      );
      
      
      
      if (data.success && data.dataContent && data.dataContent.length > 0) {
        // Extract total from dataContent array
        const individualSmamCountValue = parseInt(data.dataContent[0].individual_SMAM) || 0;
        setIndividualSmamCount(individualSmamCountValue);
        // Also set the details array so the details table can render
        setSmamIndividualDetails(data.dataContent);
        console.log('State Individual SMAM Count from total:', individualSmamCountValue);
        console.log('State Individual SMAM details set:', data.dataContent);
      } else {
        setIndividualSmamCount(0);
        setSmamIndividualDetails([]);
        console.log('No State Individual SMAM data received or invalid format:', data);
      }
    } catch (error) {
      console.error('Error fetching State Individual SMAM count:', error);
      setIndividualSmamCount(0);
    }
  };

  const fetchIndividualCrmSurveyCount = async () => {
    try {
      const { data } = await axios.post(
        `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/CentralDashBoardAll`,
        {
          flag: "EXP_SMAM_State",
          finYear: ""
        },
        {
          headers: {
            accept: '*/*',
            'Content-Type': 'application/json'
          }
        }
      );

      if (data && data.success && Array.isArray(data.dataContent) && data.dataContent.length > 0) {
        const totalCount = data.dataContent.reduce((sum, item) => {
          return sum + (parseInt(item.crM_Individual ?? item.total ?? item.count ?? 0, 10) || 0);
        }, 0);
        setIndividualCrmCount(totalCount);
      } else {
        setIndividualCrmCount(0);
      }
    } catch (error) {
      console.error('Error fetching Individual CRM survey count:', error);
      setIndividualCrmCount(0);
    }
  };

  const fetchIndividualCrmSurveyDetails = async () => {
    try {
      const { data } = await axios.post(
        `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/CentralDashBoardAll`,
        {
          flag: "EXP_CRM_State",
          finYear: ""
        },
        {
          headers: {
            accept: '*/*',
            'Content-Type': 'application/json'
          }
        }
      );

      if (data && data.success && Array.isArray(data.dataContent)) {
        const transformedData = data.dataContent.map(item => ({
          stateCode: item.stateCode || item.districtCode || 0,
          stateName: item.stateName ?? item.districtNames ?? 'N/A',
          total: parseInt(item.total ?? item.count ?? item.crM_Individual ?? 0, 10) || 0
        }));
        setIndividualCrmSurveyDetails(transformedData);
      } else {
        setIndividualCrmSurveyDetails([]);
      }
    } catch (error) {
      console.error('Error fetching Individual CRM survey details:', error);
      setIndividualCrmSurveyDetails([]);
    }
  };

  const handleIndividualCrmToggle = async (idx, item) => {
    try {
      if (expandedIndividualCrmIndex === idx) {
        setExpandedIndividualCrmIndex(-1);
        setExpandedIndividualCrmDistrictData([]);
        return;
      }

      setExpandedIndividualCrmIndex(idx);
      setLoadingIndividualCrmDistrict(true);

      const { data } = await axios.post(
        `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/CentralDashBoardAll`,
        {
          flag: "EXP_CRM_District",
          finYear: "",
          stateCode: parseInt(item.stateCode) || 0
        },
        {
          headers: {
            accept: '*/*',
            'Content-Type': 'application/json'
          }
        }
      );

      if (data && data.success && Array.isArray(data.dataContent)) {
        const transformedDistricts = data.dataContent.map(district => {
          const districtLabel = getDistrictLabel(district);
          return {
            districtCode: district.districtCode,
            districtName: districtLabel,
            districtNames: districtLabel,
            total: parseInt(district.total ?? district.count ?? 0, 10) || 0
          };
        });
        setExpandedIndividualCrmDistrictData(transformedDistricts);
      } else {
        setExpandedIndividualCrmDistrictData([]);
      }
    } catch (error) {
      console.error('Error fetching Individual CRM district details:', error);
      setExpandedIndividualCrmDistrictData([]);
    } finally {
      setLoadingIndividualCrmDistrict(false);
    }
  };

  const fetchCHCCount = async () => {
    try {
      const userRoleCode = sessionStorage.getItem("userRoleCodeModel");
      const stateCode = sessionStorage.getItem("stateNameModel");
      const userTypeCode = sessionStorage.getItem("userTypeCodeModel");
      
      console.log('fetchCHCCount - State Admin API call');
      
      // Use dynamic userTypeCode from session storage
      let apiStateCode = parseInt(stateCode);
      
      const { data } = await axios.post(
        `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/GetDashboarSurveyorReportCountState`,
        {
          "flag": "CHCCount",
          "userTypeCode": 2,//parseInt(userTypeCode),
          "stateCode": apiStateCode
        },
        {
          headers: {
            'accept': '*/*',
            'Content-Type': 'application/json'
          }
        }
      );
      
      if (data.success && data.dataContent && data.dataContent.length > 0) {
        // Extract total from dataContent array
        const chcCountValue = parseInt(data.dataContent[0].total) || 0;
        setChcCount(chcCountValue);
        console.log('State CHC Count from total:', chcCountValue);
      } else if (data.success && data.total) {
        const chcCountValue = parseInt(data.total.toString()) || 0;
        setChcCount(chcCountValue);
        console.log('State CHC Count from recordCount (fallback):', chcCountValue);
      } else {
        setChcCount(0);
        console.log('No State CHC data received or invalid format');
      }
    } catch (error) {
      console.error('Error fetching State CHC count:', error);
      setChcCount(0);
    }
  };

  // Fetch API Data Report count
  const fetchAPIDataReport = async () => {
    try {
      const stateCode = sessionStorage.getItem("stateNameModel");
      
      console.log('fetchAPIDataReport - State Admin API call');
      console.log('Using stateCode:', stateCode);
      
      const { data } = await axios.post(
        `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/APIDataReport`,
        {
          "finYear": "",
          "stateCode": parseInt(stateCode) || 0,
          "districtCode": 0,
          "subdistrictCode": 0,
          "userTypeCode": 0
        },
        {
          headers: {
            'accept': '*/*',
            'Content-Type': 'application/json'
          }
        }
      );
      
      console.log('API Data Report Response:', data);
      
      let recordCount = 0;
      if (data && data.success) {
        // API returns recordCount at the top level
        if (data.recordCount !== undefined && data.recordCount !== null) {
          recordCount = parseInt(data.recordCount) || 0;
        } else if (data.dataContent && Array.isArray(data.dataContent)) {
          // Fallback: use dataContent length if recordCount is not available
          recordCount = data.dataContent.length;
        }
      }
      
      console.log('Extracted recordCount:', recordCount);
      setApiDataReportCount(recordCount);
    } catch (error) {
      console.error('Error fetching API Data Report count:', error);
      setApiDataReportCount(0);
    }
  };

  // Fetch API Data Report Details
  const fetchAPIDataReportDetails = async (finYear = "") => {
    try {
      const stateCode = sessionStorage.getItem("stateNameModel");
      
      console.log('fetchAPIDataReportDetails - State Admin API call');
      console.log('Using stateCode:', stateCode);
      console.log('Using finYear:', finYear);
      
      const { data } = await axios.post(
        `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/APIDataReport`,
        {
          "finYear": finYear || "",
          "stateCode": parseInt(stateCode) || 0,
          "districtCode": 0,
          "subdistrictCode": 0,
          "userTypeCode": 0
        },
        {
          headers: {
            'accept': '*/*',
            'Content-Type': 'application/json'
          }
        }
      );

      console.log('API Data Report Details Response:', data);

      if (data && data.success && data.dataContent && Array.isArray(data.dataContent)) {
        // Group data by district and count records per district
        const districtGroupMap = {};
        
        data.dataContent.forEach((item) => {
          const districtName = item.districtName || 'N/A';
          const districtCode = item.districtCode || 0;
          
          if (!districtGroupMap[districtName]) {
            districtGroupMap[districtName] = {
              districtName: districtName,
              districtCode: districtCode,
              recordCount: 0
            };
          }
          districtGroupMap[districtName].recordCount += 1;
        });
        
        // Convert map to array
        const transformedData = Object.values(districtGroupMap);
        
        console.log('Transformed API Data Report Details (grouped by district):', transformedData);
        setApiDataReportDetails(transformedData);
      } else {
        console.log('No data content found in response');
        setApiDataReportDetails([]);
      }
    } catch (error) {
      console.error('Error fetching API Data Report details:', error);
      setApiDataReportDetails([]);
    }
  };

  // Handle API Data Report district toggle
  const handleApiDataReportToggle = async (index, districtItem) => {
    if (expandedApiDataReportIndex === index) {
      setExpandedApiDataReportIndex(null);
      setExpandedApiDataReportDistrictData([]);
      setExpandedApiDataReportDistrictIndex(null);
      setExpandedApiDataReportDistrictDetailsData([]);
      return;
    }

    setExpandedApiDataReportIndex(index);
    setExpandedApiDataReportDistrictIndex(null);
    setExpandedApiDataReportDistrictDetailsData([]);
    try {
      const stateCode = sessionStorage.getItem("stateNameModel");
      
      const { data } = await axios.post(
        `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/APIDataReport`,
        {
          "finYear": selectedFinYear || "",
          "stateCode": parseInt(stateCode) || 0,
          "districtCode": parseInt(districtItem.districtCode) || 0,
          "subdistrictCode": 0,
          "userTypeCode": 0
        },
        {
          headers: {
            'accept': '*/*',
            'Content-Type': 'application/json'
          }
        }
      );

      console.log('API Data Report District Response:', data);

      if (data && data.success && data.dataContent && Array.isArray(data.dataContent)) {
        // Group data by sub-district and count records per sub-district
        const subDistrictGroupMap = {};
        
        data.dataContent.forEach((item) => {
          const subDistrictName = item.subdistrictName || item.blockName || 'N/A';
          const subDistrictCode = item.subdistrictCode || item.blockCode || 0;
          
          if (!subDistrictGroupMap[subDistrictName]) {
            subDistrictGroupMap[subDistrictName] = {
              blockName: subDistrictName,
              blockCode: subDistrictCode,
              recordCount: 0
            };
          }
          subDistrictGroupMap[subDistrictName].recordCount += 1;
        });
        
        // Convert map to array
        const transformedData = Object.values(subDistrictGroupMap);
        
        console.log('Transformed API Data Report Sub-District Details:', transformedData);
        setExpandedApiDataReportDistrictData(transformedData);
      } else {
        console.log('No district data content found in response');
        setExpandedApiDataReportDistrictData([]);
      }
    } catch (error) {
      console.error('Error fetching API Data Report district details:', error);
      setExpandedApiDataReportDistrictData([]);
    }
  };

  // Handle API Data Report sub-district/block toggle
  const handleApiDataSubDistrictReportToggle = async (index, subDistrictItem, districtItem) => {
    if (expandedApiDataReportSubDistrictIndex === index) {
      setExpandedApiDataReportSubDistrictIndex(null);
      setExpandedApiDataReportSubDistrictDetailsData([]);
      return;
    }

    setExpandedApiDataReportSubDistrictIndex(index);
    try {
      const stateCode = sessionStorage.getItem("stateNameModel");
      
      const { data } = await axios.post(
        `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/APIDataReport`,
        {
          "finYear": selectedFinYear || "",
          "stateCode": parseInt(stateCode) || 0,
          "districtCode": parseInt(districtItem.districtCode) || 0,
          "subdistrictCode": parseInt(subDistrictItem.blockCode || subDistrictItem.subdistrictCode) || 0,
          "userTypeCode": 0
        },
        {
          headers: {
            'accept': '*/*',
            'Content-Type': 'application/json'
          }
        }
      );

      console.log('API Data Report SubDistrict/Village Response:', data);

      if (data && data.success && data.dataContent && Array.isArray(data.dataContent)) {
        // Store the raw data or group by village if needed
        // For now, we'll show all records for this subdistrict
        const transformedData = data.dataContent.map((item, idx) => ({
          id: item.chcId || item.id || idx + 1,
          chcName: item.chcName || 'N/A',
          villageName: item.villageName || 'N/A',
          recordCount: 1,
          ...item
        }));
        
        console.log('Transformed API Data Report SubDistrict Details:', transformedData);
        setExpandedApiDataReportSubDistrictDetailsData(transformedData);
      } else {
        console.log('No subdistrict/village data content found in response');
        setExpandedApiDataReportSubDistrictDetailsData([]);
      }
    } catch (error) {
      console.error('Error fetching API Data Report subdistrict details:', error);
      setExpandedApiDataReportSubDistrictDetailsData([]);
    }
  };

  // Handle Financial Year change
  const handleFinYearChange = async (e) => {
    const selectedYear = e.target.value;
    setSelectedFinYear(selectedYear);
    setExpandedApiDataReportIndex(null);
    setExpandedApiDataReportDistrictData([]);
    setExpandedApiDataReportDistrictIndex(null);
    setExpandedApiDataReportDistrictDetailsData([]);
    setExpandedApiDataReportSubDistrictIndex(null);
    setExpandedApiDataReportSubDistrictDetailsData([]);
    await fetchAPIDataReportDetails(selectedYear);
  };

  // Handle image view
  const handleImageView = (imagePath) => {
    if (imagePath) {
      setSelectedImageUrl(imagePath);
      setShowImageModal(true);
    }
  };

  // Close image modal
  const handleCloseImageModal = () => {
    setShowImageModal(false);
    setSelectedImageUrl(null);
  };

  // Handle implement details view
  const handleImplementsClick = (chc) => {
    if (chc && chc.noOfImplements > 0) {
      setSelectedImplements(chc);
      setShowImplementsModal(true);
    }
  };

  // Close implement modal
  const handleCloseImplementsModal = () => {
    setShowImplementsModal(false);
    setSelectedImplements(null);
  };

  // Handle user type toggle and fetch state data
  const handleUserTypeToggle = async (index, userType) => {
    if (expandedUserTypeIndex === index) {
      setExpandedUserTypeIndex(-1);
      setStateData([]);
      return;
    }

    setExpandedUserTypeIndex(index);
    setExpandedStateIndex(-1);
    setDistrictData([]);

    try {
      const stateCode = sessionStorage.getItem("stateNameModel");
      const { data } = await axios.post(
        `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/GetStateDashboarCount`,
        {
          flag: userType === "SMAM" ? "State" : "CRMUserTyp",
          stateCode: parseInt(stateCode),
          userTypeCode: userType === "SMAM" ? 3 : 0
        },
        {
          headers: {
            'accept': '*/*',
            'Content-Type': 'application/json'
          }
        }
      );

      if (data.success && data.dataContent) {
        setStateData(data.dataContent);
      }
    } catch (error) {
      console.error('Error fetching state data:', error);
      setStateData([]);
    }
  };

  // Handle state toggle and fetch district data
  const handleStateToggle = async (index, state, userType) => {
    if (expandedStateIndex === index) {
      setExpandedStateIndex(-1);
      setDistrictData([]);
      return;
    }

    setExpandedStateIndex(index);

    try {
      // Check if it's ICAR or State
      if (state.category === 'ICAR') {
        const icarResponse = await axios.post(
          `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/GetStateDashboarCount`,
          {
            flag: "ICARDETAIL",
            stateCode: parseInt(sessionStorage.getItem("stateNameModel")),
            userTypeCode: 0
          },
          {
            headers: {
              'accept': '*/*',
              'Content-Type': 'application/json'
            }
          }
        );

        if (icarResponse.data.success && icarResponse.data.dataContent) {
          setDistrictData(icarResponse.data.dataContent);
        }
      } else if (state.category === "SMAM") {
        // For SMAM user type
        const response = await axios.post(
          `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/GetStateDashboarCount`,
          {
            flag: "State",
            stateCode: parseInt(sessionStorage.getItem("stateNameModel")),
            userTypeCode: 3
          },
          {
            headers: {
              'accept': '*/*',
              'Content-Type': 'application/json'
            }
          }
        );

        if (response.data.success && response.data.dataContent) {
          setDistrictData(response.data.dataContent);
        }
      } else {
        // For other cases, make the District API call
        const districtResponse = await axios.post(
          `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/GetStateDashboarCount`,
          {
            flag: "District",
            stateCode: parseInt(sessionStorage.getItem("stateNameModel")),
            userTypeCode: userType === "SMAM" ? 3 : 2
          },
          {
            headers: {
              'accept': '*/*',
              'Content-Type': 'application/json'
            }
          }
        );

        if (districtResponse.data.success && districtResponse.data.dataContent) {
          setDistrictData(districtResponse.data.dataContent);
        }
      }
    } catch (error) {
      console.error('Error fetching district data:', error);
      setDistrictData([]);
    }
  };

  // Handle surveyor drill-down and navigate to detail view
  const handleSurveyorDrillDown = async (surveyorName, districtName, surveyorId) => {
    try {
      if (selectedSurveyor === surveyorName) {
        setSelectedSurveyor(null);
        return;
      }

      setSelectedSurveyor(surveyorName);
      
      const response = await axios.post(
        `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/Get_CHCDetailByID`,
        {
          surveyorUserCode: parseInt(surveyorId)
        },
        {
          headers: {
            'accept': '*/*',
            'Content-Type': 'application/json'
          }
        }
      );

      if (response.data.success && response.data.dataContent) {
        // Navigate to SurveyorDetailView with the farmer data
        navigate('/MNT/surveyorDetail', {
          state: {
            farmerData: response.data.dataContent[0],
            returnTo: '/MNT/dashboardMnT',
            expandedRows: selectedDistrict,
            expandedSurveyorRows: selectedSurveyor,
            surveyorDetailsByDistrict: districtDrillDownData,
            farmerDetailsBySurveyor: surveyorFarmerData
          }
        });
      } else {
        console.log('No farmer data available for this surveyor');
        alert('No farmer data available for this surveyor');
      }
    } catch (error) {
      console.error('Error fetching farmer data:', error);
      alert('Error fetching farmer details. Please try again.');
    }
  };

  // Handle district drill-down
  const handleDistrictDrillDown = async (districtCode, districtName) => {
    try {
      if (selectedDistrict === districtCode) {
        setSelectedDistrict(null);
        return;
      }

      setSelectedDistrict(districtCode);
      const stateCode = sessionStorage.getItem("stateNameModel");
      
      const response = await axios.post(
        `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/GetDistrictDashboarCount`,
        {
          flag: "Surveyor",
          userTypeCode: 3,
          stateCode: parseInt(stateCode),
          districtCode: districtCode.toString()
        },
        {
          headers: {
            'accept': '*/*',
            'Content-Type': 'application/json'
          }
        }
      );

      if (response.data.success && response.data.dataContent) {
        setDistrictDrillDownData({
          ...districtDrillDownData,
          [districtCode]: {
            data: response.data.dataContent,
            name: districtName
          }
        });
      } else {
        console.log('No district drill-down data available');
        setDistrictDrillDownData({
          ...districtDrillDownData,
          [districtCode]: {
            data: [],
            name: districtName
          }
        });
      }
    } catch (error) {
      console.error('Error fetching district drill-down data:', error);
      alert('Error fetching district details. Please try again.');
    }
  };

  // Handle district toggle and fetch surveyor data
  const toggleSurveyorExpansion = async (surveyor, surveyorKey) => {
    if (isSurveyorExpanded) {
      setIsSurveyorExpanded(false);
      setFarmerData([]);
      return;
    }

    setLoadingFarmers(prev => ({ ...prev, [surveyorKey]: true }));
    try {
      const response = await axios.post(
        `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/Farmers/GetMTFarmerRegData`,
        {
          createdBy: parseInt(surveyor.userCode || surveyor.id)
        },
        {
          headers: {
            'accept': '*/*',
            'Content-Type': 'application/json'
          }
        }
      );

      if (response.data.success && response.data.dataContent) {
        setFarmerData(response.data.dataContent);
        setIsSurveyorExpanded(true);
      } else {
        setFarmerData([]);
        alert('No farmer data available for this surveyor.');
      }
    } catch (error) {
      console.error('Error fetching farmer data:', error);
      alert('Error fetching farmer data. Please try again.');
      setFarmerData([]);
    } finally {
      setLoadingFarmers(prev => ({ ...prev, [surveyorKey]: false }));
    }
  };

  const handleDistrictToggle = async (index, district, userType) => {
    if (expandedDistrictIndex === index) {
      setExpandedDistrictIndex(-1);
      setSurveyorData([]);
      return;
    }

    setExpandedDistrictIndex(index);

    try {
      const stateCode = parseInt(sessionStorage.getItem("stateNameModel"));
      const userTypeCodeValue = userType === "SMAM" ? 3 : 2;
      
      console.log('🔍 Fetching surveyor data for district:', district.districtNames);
      console.log('🔍 District Code:', district.districtCode);
      console.log('🔍 State Code:', stateCode);
      console.log('🔍 User Type Code:', userTypeCodeValue);

      const response = await axios.post(
        `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/GetDistrictDashboarCount`,
        {
          flag: "Surveyor",
          userTypeCode: userTypeCodeValue,
          stateCode: stateCode,
          districtCode: district.districtCode.toString()
        },
        {
          headers: {
            'accept': '*/*',
            'Content-Type': 'application/json'
          }
        }
      );

      console.log('🎯 Surveyor Data Response:', response.data);

      if (response.data.success && response.data.dataContent) {
        setSurveyorData(response.data.dataContent);
        console.log('✅ Surveyor data loaded:', response.data.dataContent.length);
      } else {
        setSurveyorData([]);
        console.log('⚠️ No surveyor data found');
      }
    } catch (error) {
      console.error('❌ Error fetching surveyor data:', error);
      setSurveyorData([]);
    }
  };

  // Fetch user types for initial drill-down table
  const fetchStateDetails = async () => {
    try {
      const stateCode = sessionStorage.getItem("stateNameModel");
      const { data } = await axios.post(
        `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/GetStateDashboarCount`,
        {
          flag: "UserType",
          stateCode: parseInt(stateCode),
          userTypeCode: parseInt(userTypeCode)
        },
        {
          headers: {
            accept: "*/*",
            "Content-Type": "application/json"
          }
        }
      );

      const rows = (data && data.dataContent) ? data.dataContent : [];
      setStateDetails(Array.isArray(rows) ? rows : []);
      return Array.isArray(rows) ? rows : [];
    } catch (error) {
      console.error("Error fetching State details:", error);
      setStateDetails([]);
      return [];
    }
  };

  // Fetch CRM CHC details
  const fetchCRMChcDetails = async () => {
    try {
      const stateCode = sessionStorage.getItem("stateNameModel");
      console.log('Fetching CRM CHC details for state:', stateCode);
      
      const { data } = await axios.post(
        `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/GetDashboarSurveyorReportCountState`,
        {
          "flag": "CHCCountS",
          "userTypeCode": 2,  // Fixed value for CRM CHC
          "stateCode": parseInt(stateCode) || 0
        },
        {
          headers: {
            'accept': '*/*',
            'Content-Type': 'application/json'
          }
        }
      );

      console.log('CRM CHC API Response:', data);
      
      if (data.success && data.dataContent && data.dataContent.length > 0) {
        setCrmChcDetails(data.dataContent);
        console.log('CRM CHC details set:', data.dataContent);
      } else {
        setCrmChcDetails([]);
        console.log('No CRM CHC data received or invalid format');
      }
    } catch (error) {
      console.error('Error fetching CRM CHC details:', error);
      setCrmChcDetails([]);
    }
  };

  // Handle SMAM CHC toggle and fetch detailed data
  const handleSMAMCHCToggle = async (idx, item) => {
    try {
      if (expandedSMAMIndex === idx) {
        // If clicking on already expanded row, collapse it
        setExpandedSMAMIndex(-1);
        return;
      }

      setExpandedSMAMIndex(idx);
      setLocalLoading(true);

      const { data } = await axios.post(
        `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/GetDashboarSurveyorReportCountState`,
        {
          "flag": "CHCCountD",
          "stateCode": parseInt(item.stateCode),
          "userTypeCode": 3
        },
        {
          headers: {
            'accept': '*/*',
            'Content-Type': 'application/json'
          }
        }
      );

      console.log('SMAM CHC Detailed API Response:', data);
      
      if (data.success && data.dataContent) {
        setSmamChcDetailedData(prevState => ({
          ...prevState,
          [idx]: data.dataContent
        }));
      } else {
        console.log('No detailed data found for SMAM CHC');
        setSmamChcDetailedData(prevState => ({
          ...prevState,
          [idx]: []
        }));
      }
    } catch (error) {
      console.error('Error fetching SMAM CHC detailed data:', error);
      setExpandedSMAMIndex(-1);
    } finally {
      setLocalLoading(false);
    }
  };
// Handle SMAM Individual toggle and fetch detailed data
  const handleSMAMIndToggle = async (idx, item) => {
    try {
      if (expandedSMAMIndex === idx) {
        // If clicking on already expanded row, collapse it
        setExpandedSMAMIndex(-1);
        return;
      }

      setExpandedSMAMIndex(idx);
      setLocalLoading(true);

      const { data } = await axios.post(
        `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/GetDashboarSurveyorReportCountState`,
        {
          "flag": "SMAM_Individual_D",
          "stateCode": parseInt(sessionStorage.getItem("stateNameModel")),
          "userTypeCode": 3
        },
        {
          headers: {
            'accept': '*/*',
            'Content-Type': 'application/json'
          }
        }
      );

      console.log('SMAM CHC Detailed API Response:', data);
      
      if (data.success && data.dataContent) {
        setSmamChcDetailedData(prevState => ({
          ...prevState,
          [idx]: data.dataContent
        }));
      } else {
        console.log('No detailed data found for SMAM CHC');
        setSmamChcDetailedData(prevState => ({
          ...prevState,
          [idx]: []
        }));
      }
    } catch (error) {
      console.error('Error fetching SMAM CHC detailed data:', error);
      setExpandedSMAMIndex(-1);
    } finally {
      setLocalLoading(false);
    }
  };
  // Handle CRM CHC toggle and fetch detailed data
  const handleCRMCHCToggle = async (idx, item) => {
    try {
      if (expandedCRMIndex === idx) {
        // If clicking on already expanded row, collapse it
        setExpandedCRMIndex(-1);
        return;
      }setExpandedCRMIndex(idx);
      setLocalLoading(true);

      const { data } = await axios.post(
        `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/GetDashboarSurveyorReportCountState`,
        {
          "flag": "CHCCountD",
          "stateCode": parseInt(item.stateCode) || 0,
          "userTypeCode": 2
        },
        {
          headers: {
            'accept': '*/*',
            'Content-Type': 'application/json'
          }
        }
      );

      console.log('CRM CHC Detailed API Response:', data);
      
      if (data.success && data.dataContent) {
        setCrmChcDetailedData(prevState => ({
          ...prevState,
          [idx]: data.dataContent
        }));
      } else {
        console.log('No detailed data found for CRM CHC');
        setCrmChcDetailedData(prevState => ({
          ...prevState,
          [idx]: []
        }));
      }
    } catch (error) {
      console.error('Error fetching CRM CHC detailed data:', error);
      setExpandedCRMIndex(-1);
    } finally {
      setLocalLoading(false);
    }
  };

  // Fetch SMAM CHC details
  const fetchSMAMChcDetails = async () => {
    try {
      const stateCode = sessionStorage.getItem("stateNameModel");
      console.log('Fetching SMAM CHC details for state:', stateCode);
      
      const { data } = await axios.post(
        `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/GetDashboarSurveyorReportCountState`,
        {
          "flag": "CHCCountS",
          "userTypeCode": 3,  // Fixed value for SMAM CHC
          "stateCode": parseInt(sessionStorage.getItem("stateNameModel"))
        },
        {
          headers: {
            'accept': '*/*',
            'Content-Type': 'application/json'
          }
        }
      );

      console.log('SMAM CHC API Response:', data);
      
      if (data.success && data.dataContent && data.dataContent.length > 0) {
        setSmamChcDetails(data.dataContent);
        console.log('SMAM CHC details set:', data.dataContent);
      } else {
        setSmamChcDetails([]);
        console.log('No SMAM CHC data received or invalid format');
      }
    } catch (error) {
      console.error('Error fetching SMAM CHC details:', error);
      setSmamChcDetails([]);
    }
  };

   const fetchSMAMindividualDetails = async () => {
    try {
      const stateCode = sessionStorage.getItem("stateNameModel");
      console.log('Fetching SMAM CHC details for state:', stateCode);
      
      const { data } = await axios.post(
        `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/GetDashboarSurveyorReportCountState`,
        {
          "flag": "SMAM_Individual_S",
          "userTypeCode": 3,  // Fixed value for SMAM CHC
          "stateCode": parseInt(sessionStorage.getItem("stateNameModel"))
        },
        {
          headers: {
            'accept': '*/*',
            'Content-Type': 'application/json'
          }
        }
      );

      console.log('SMAM CHC API Response:', data);
      
      if (data.success && data.dataContent && data.dataContent.length > 0) {
        setSmamChcDetails(data.dataContent);
        console.log('SMAM CHC details set:', data.dataContent);
      } else {
        setSmamChcDetails([]);
        console.log('No SMAM CHC data received or invalid format');
      }
    } catch (error) {
      console.error('Error fetching SMAM CHC details:', error);
      setSmamChcDetails([]);
    }
  };


  // Handle More Info clicks locally
  const handleLocalMoreInfo = async (type) => {
    // If clicking the same table, toggle it off
    if (activeTable === type) {
      setActiveTable('none');
      setExpandedCRMIndex(-1);
      setExpandedApiDataReportIndex(null);
      setExpandedApiDataReportDistrictData([]);
      setExpandedIndividualCrmIndex(-1);
      setExpandedIndividualCrmDistrictData([]);
      return;
    }

    // Set the new active table
    setActiveTable(type);
    setExpandedCRMIndex(-1);
    setExpandedApiDataReportIndex(null);
    setExpandedApiDataReportDistrictData([]);
    setExpandedApiDataReportDistrictIndex(null);
    setExpandedApiDataReportDistrictDetailsData([]);
    setExpandedApiDataReportSubDistrictIndex(null);
    setExpandedApiDataReportSubDistrictDetailsData([]);

    if (type === 'user') {
      setLocalLoading(true);
      try {
        await fetchStateDetails();
      } finally {
        setLocalLoading(false);
      }
    } else if (type === 'crmChc' && isCRMComponent) {
      setLocalLoading(true);
      try {
        await fetchCRMChcDetails();
      } finally {
        setLocalLoading(false);
      }
    } else if (type === 'smamInd') {
      setLocalLoading(true);
      try {
        await fetchSMAMindividualDetails();
      } finally {
        setLocalLoading(false);
      }
    } else if (type === 'smamChc') {
      setLocalLoading(true);
      try {
        await fetchSMAMChcDetails();
      } finally {
        setLocalLoading(false);
      }
    } else if (type === 'individualCrmSurvey' && isCRMComponent) {
      setExpandedIndividualCrmIndex(-1);
      setExpandedIndividualCrmDistrictData([]);
      setLocalLoading(true);
      try {
        await fetchIndividualCrmSurveyDetails();
      } finally {
        setLocalLoading(false);
      }
    } else if (type === 'apiDataReport' && isCRMComponent) {
      setLocalLoading(true);
      try {
        await fetchAPIDataReportDetails(selectedFinYear);
      } finally {
        setLocalLoading(false);
      }
    }  else if (typeof handleMoreInfoClick === "function") {
      handleMoreInfoClick(type);
    }
  };

  // Fetch data when component mounts
  useEffect(() => {
    const fetchStateData = async () => {
      setLocalLoading(true);
      try {
        const promises = [
          fetchUserCount(),
          fetchSMAMCHCCount(),
          fetchIndividualSMAMCCount()
        ];
        
        // Only fetch CRM CHC count and API Data Report if it's a CRM component
        if (isCRMComponent) {
          promises.push(fetchCHCCount());
          promises.push(fetchAPIDataReport());
          promises.push(fetchIndividualCrmSurveyCount());
        }
        
        await Promise.all(promises);
      } finally {
        setLocalLoading(false);
      }
    };

    fetchStateData();
  }, [isCRMComponent]);
  return (
    <>
      {/* User Count Card */}
      <div className="col-xxl-4 col-xl-4">
        <div className="card info-card sales-card bg-gradient-danger card-img-holder">
          <div className="card-body">
            <img src={Circles} className="card-img-absolute" alt="circle-image" />
            <h5 className="card-title">User Count</h5>
            <div className="d-flex align-items-center">
              <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                <i><FontAwesomeIcon icon={faUsers} /> </i>
              </div>
              <div className="ps-3">
                <h6 id="totalUsers">{loading || localLoading ? 'Loading...' : userCount}</h6>
              </div>
            </div>
            <div className="mt-3">
              <button
                className='btn btn-link p-0 text-white'
                onClick={() => handleLocalMoreInfo('user')}
                title="Click for more information"
              >
                <i className="bi bi-arrow-right-circle-fill fs-6">More Info</i>
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* SMAM CHC Survey Count Card */}
      <div className="col-xxl-4 col-xl-4">
        <div className="card info-card sales-card bg-gradient-primary card-img-holder">
          <div className="card-body">
            <img src={Circles} className="card-img-absolute" alt="circle-image" />
            <h5 className="card-title">SMAM CHC Survey Count</h5>
            <div className="d-flex align-items-center">
              <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                <i><FontAwesomeIcon icon={faUsers} /> </i>
              </div>
              <div className="ps-3">
                <h6 id="total">{loading || localLoading ? 'Loading...' : smamchcHistoryCount}</h6>
              </div>
            </div>
            <div className="mt-3">
              <button
                className='btn btn-link p-0 text-white'
                onClick={() => handleLocalMoreInfo('smamChc')}
                title="Click for more information"
              >
                <i className="bi bi-arrow-right-circle-fill fs-6">More Info</i>
              </button>
            </div>
          </div>
        </div>
      </div>
      {isCRMComponent && (
      <div className="col-xxl-4 col-xl-4">
        <div className="card info-card sales-card bg-gradient-danger card-img-holder">
          <div className="card-body">
              <img src={Circles} className="card-img-absolute" alt="circle-image" />
              <h5 className="card-title">CRM CHC Survey Count</h5>
              <div className="d-flex align-items-center">
                <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                  <i><FontAwesomeIcon icon={faUsers} /> </i>
                </div>
                <div className="ps-3">
                  <h6 id="total">{loading || localLoading ? 'Loading...' : chcCount}</h6>
                </div>
              </div>
              <div className="mt-3">
                <button
                  className='btn btn-link p-0 text-white'
                  onClick={() => handleLocalMoreInfo('crmChc')}
                  title="Click for more information"
                >
                  <i className="bi bi-arrow-right-circle-fill fs-6">More Info</i>
                </button>
              </div>
            </div>
          </div>
       </div>
         )}   
        
        {isCRMComponent && sessionStorage.getItem("stateNameModel") === "3" && (
        <div className="col-xxl-4 col-xl-4">
          <div className="card info-card sales-card bg-gradient-mid card-img-holder">
            <div className="card-body">
              <img src={Circles} className="card-img-absolute" alt="circle-image" />
              <h5 className="card-title">CRM CHC Data- API</h5>
              <div className="d-flex align-items-center">
                <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                  <i><FontAwesomeIcon icon={faUsers} /> </i>
                </div>
                <div className="ps-3">
                  <h6 id="recordCount">{loading || localLoading ? 'Loading...' : apiDataReportCount}</h6>
                </div>
              </div>
              <div className="mt-3">
                <button 
                  className='btn btn-link p-0 text-white' 
                  onClick={() => handleLocalMoreInfo('apiDataReport')}
                  title="Click for more information"
                >
                  <i className="bi bi-arrow-right-circle-fill fs-6">More Info</i>
                </button>
              </div>
            </div>
          </div>
        
        </div>
       
      )}
{isCRMComponent &&(
  <div className="col-xxl-4 col-xl-4">
                  <div className="card info-card sales-card bg-gradient-danger card-img-holder">
                    <div className="card-body">
                      <img src={Circles} className="card-img-absolute" alt="circle-image" />
                      <h5 className="card-title">Individual Crm Survey</h5>
                      <div className="d-flex align-items-center">
                        <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                          <i><FontAwesomeIcon icon={faUsers} /> </i>
                        </div>
                        <div className="ps-3">
                          <h6 id="individualCrmCount">{loading || localLoading ? 'Loading...' : individualcrmCount}</h6>
                        </div>
                      </div>
                      <div className="mt-3">
                        <button 
                          className='btn btn-link p-0 text-white' 
                          onClick={() => handleLocalMoreInfo('individualCrmSurvey')}
                          title="Click for more information"
                        >
                          <i className="bi bi-arrow-right-circle-fill fs-6">More Info</i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
       
)}
{/* Individual SMAM Survey Count Card */}
      <div className="col-xxl-4 col-xl-4">
        <div className="card info-card sales-card bg-gradient-lite card-img-holder">
          <div className="card-body">
            <img src={Circles} className="card-img-absolute" alt="circle-image" />
            <h5 className="card-title">Individual SMAM Survey </h5>
            <div className="d-flex align-items-center">
              <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                <i><FontAwesomeIcon icon={faUsers} /> </i>
              </div>
              <div className="ps-3">
                <h6 id="individual_SMAM">{loading || localLoading ? 'Loading...' : individualsmamCount}</h6>
              </div>
            </div>
            <div className="mt-3">
              <button
                className='btn btn-link p-0 text-white'
                onClick={() => handleLocalMoreInfo('smamInd')}
                title="Click for more information"
              >
                <i className="bi bi-arrow-right-circle-fill fs-6">More Info</i>
              </button>
            </div>
          </div>
        </div>
      </div>
      {activeTable === 'individualCrmSurvey' && (
        <div className="col-12">
          <h5>Individual CRM Survey Details</h5>
          <div className="d-flex justify-content-end mb-2">
            <button 
              className="btn btn-success" 
              onClick={() => exportToCSV(individualCrmSurveyDetails, "MT_Individual_CRM_Report", ["S.No", "stateName", "total"])}
            >
              Export CSV
            </button>
          </div>
          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr className="table-light">
                  <th>Sr. No.</th>
                  <th>State</th>
                  <th>Count</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {individualCrmSurveyDetails && individualCrmSurveyDetails.length > 0 ? (
                  individualCrmSurveyDetails.map((item, index) => (
                    <React.Fragment key={index}>
                      <tr>
                        <td>{index + 1}</td>
                        <td>{item.stateName || 'N/A'}</td>
                        <td>{item.total || 0}</td>
                        <td>
                          <span 
                            role="button"
                            onClick={() => handleIndividualCrmToggle(index, item)}
                            style={{
                              cursor: "pointer",
                              color: "#0d6efd",
                              fontSize: "16px",
                              fontWeight: "bold"
                            }}
                          >
                            {expandedIndividualCrmIndex === index ? "-" : "+"}
                          </span>
                        </td>
                      </tr>
                      {expandedIndividualCrmIndex === index && (
                        <tr>
                          <td colSpan={4}>
                            {loadingIndividualCrmDistrict ? (
                              <div className="text-center py-4">
                                <div className="spinner-border text-primary" role="status">
                                  <span className="visually-hidden">Loading...</span>
                                </div>
                                <p className="mt-2 text-muted">Loading district details...</p>
                              </div>
                            ) : expandedIndividualCrmDistrictData.length > 0 ? (
                              <>
                                <div className="d-flex justify-content-between align-items-center mb-2">
                                  <h5 className="mb-0">District Details for {item.stateName}</h5>
                                  <button 
                                    className="btn btn-sm btn-outline-success" 
                                    onClick={() => exportToCSV(expandedIndividualCrmDistrictData, `MT_Individual_CRM_Districts_${item.stateName}`, ["S.No", "District Name", "Count"])}
                                  >
                                    Export CSV
                                  </button>
                                </div>
                                <table className="table table-bordered">
                                  <thead>
                                    <tr>
                                      <th>Sr. No.</th>
                                      <th>District Name</th>
                                      <th>Count</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {expandedIndividualCrmDistrictData.map((district, dIndex) => (
                                      <tr key={dIndex}>
                                        <td>{dIndex + 1}</td>
                                        <td>{district.districtNames || 'N/A'}</td>
                                        <td>{district.total || 0}</td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </>
                            ) : (
                              <div className="text-center py-3 text-muted">
                                <p>No district data available</p>
                              </div>
                            )}
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  ))
                ) : (
                  <tr>
                    <td colSpan={4} className="text-center">No Individual CRM survey data available</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}
      
      {/* SMAM CHC Survey Details Table */}
      {activeTable === 'smamChc' && (
        <div className="col-12">
          <h5>SMAM CHC Survey Details</h5>
          <div className="d-flex justify-content-end mb-2">
            <button 
              className="btn btn-success" 
              onClick={() => exportToCSV(smamChcDetails, "SMAM_CHC_Survey_Report", ["S.No", "State", "Count"])}
            >
              Export CSV
            </button>
          </div>
          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr className="table-light">
                  <th>Sr. No.</th>
                  <th>State</th>
                  <th>User Count</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {smamChcDetails && smamChcDetails.length > 0 ? (
                  smamChcDetails.map((item, index) => (
                    <>
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{item.stateName || 'N/A'}</td>
                        <td>{item.total || 0}</td>
                        <td>
                          <span 
                            role="button"
                            onClick={() => handleSMAMCHCToggle(index, item)}
                            style={{
                              cursor: "pointer",
                              color: "#0d6efd",
                              fontSize: "12px",
                              fontWeight: "bold"
                            }}
                            title="Click for more details"
                          >
                            {expandedSMAMIndex === index ? "-" : "+"}
                          </span>
                        </td>
                      </tr>
                      {expandedSMAMIndex === index && (
                        <tr>
                          <td colSpan={4} className="p-0">
                            <div className="d-flex justify-content-between align-items-center mb-2 p-2">
                              <h5 className="mb-0">District Details for {item.stateName}</h5>
                              <button 
                                className="btn btn-sm btn-outline-success" 
                                onClick={() => exportToCSV(smamChcDetailedData[index] || [], `State_SMAM_CHC_Districts_${item.stateName}`, ["S.No", "District", "User Count"])}
                              >
                                Export CSV
                              </button>
                            </div>
                            <div className="table-responsive">
                              <table className="table table-bordered m-0">
                                <thead>
                                  <tr className="table-light">
                                    <th>Sr. No.</th>
                                    <th>District Name</th>
                                    <th>User Count</th>
                                    <tH>Action</tH>
                                  </tr>
                                </thead>
                                <tbody>
                                  {smamChcDetailedData[index]?.length > 0 ? (
                                    smamChcDetailedData[index].map((detail, detailIdx) => (
                                      <>
                                        <tr key={detailIdx}>
                                          <td>{detailIdx + 1}</td>
                                          <td>{detail.districtNames}</td>
                                          <td>{detail.total || 0}</td>
                                          <td>
                                            <span 
                                              role="button"
                                              onClick={() => handleDistrictDrillDown(detail.districtCode, detail.districtNames)}
                                              style={{
                                                cursor: "pointer",
                                                color: "#0d6efd",
                                                fontSize: "12px",
                                                fontWeight: "bold"
                                              }}
                                              title="Click for district details"
                                            >
                                              {selectedDistrict === detail.districtCode ? "-" : "+"}
                                            </span>
                                          </td>
                                        </tr>
                                        {selectedDistrict === detail.districtCode && districtDrillDownData[detail.districtCode] && (
                                          <tr>
                                            <td colSpan={4}>
                                              <div className="ms-4">
                                                <div className="d-flex justify-content-between align-items-center mb-2">
                                                  <h5 className="mb-0">Surveyor Details for {districtDrillDownData[detail.districtCode].name}</h5>
                                                  <button 
                                                    className="btn btn-sm btn-outline-success" 
                                                    onClick={() => exportToCSV(
                                                      districtDrillDownData[detail.districtCode].data,
                                                      `District_Surveyors_${districtDrillDownData[detail.districtCode].name}`,
                                                      ["S.No", "Surveyor Name", "Mobile", "Email"]
                                                    )}
                                                  >
                                                    Export CSV
                                                  </button>
                                                </div>
                                                <table className="table table-bordered">
                                                  <thead>
                                                    <tr>
                                                      <th>Sr. No.</th>
                                                      <th>Surveyor Name</th>
                                                      <th>District Name</th>
                                                      <th>Action</th>
                                                    </tr>
                                                  </thead>
                                                  <tbody>
                                                    {districtDrillDownData[detail.districtCode].data.length > 0 ? (
                                                      districtDrillDownData[detail.districtCode].data.map((surveyor, idx) => (
                                                        <tr key={idx}>
                                                          <td>{idx + 1}</td>
                                                         
                                                          <td>{surveyor.surveyorName || surveyor.userName || 'N/A'}</td>
                                                          <td>{surveyor.districtName}</td>
                                                          <td>
                                                            <span 
                                                              role="button"
                                                               onClick={() => handleSurveyorDrillDown(surveyor.surveyorName, surveyor.districtName, surveyor.userCode || surveyor.id)}
                                                              style={{
                                                                cursor: "pointer",
                                                                color: "#0d6efd",
                                                                fontSize: "12px",
                                                                fontWeight: "bold"
                                                              }}
                                                            >
                                                              {selectedSurveyor === surveyor.surveyorName ? "-" : "+"}
                                                            </span>
                                                          </td>
                                                        </tr>
                                                      ))
                                                    ) : (
                                                      <tr>
                                                        <td colSpan={4} className="text-center">No surveyor data available</td>
                                                      </tr>
                                                    )}
                                                  </tbody>
                                                </table>
                                              </div>
                                            </td>
                                          </tr>
                                        )}
                                      </>
                                    ))
                                  ) : (
                                    <tr>
                                      <td colSpan={3} className="text-center">
                                        {localLoading ? 'Loading...' : 'No detailed data available'}
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </td>
                        </tr>
                      )}
                    </>
                  ))
                ) : (
                  <tr>
                    <td colSpan={4} className="text-center">No SMAM CHC survey data available</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}

{/* SMAM Individual Survey Details Table */}
      {activeTable === 'smamInd' && (
        <div className="col-12">
          <h5>SMAM Individual Survey Details</h5>
          <div className="d-flex justify-content-end mb-2">
            <button 
              className="btn btn-success" 
              onClick={() => exportToCSV(smamIndividualDetails, "SMAM_Individual_Survey_Report", ["S.No",  "Count"])}
            >
              Export CSV
            </button>
          </div>
          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr className="table-light">
                  <th>Sr. No.</th>
                  
                  <th>User Count</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {smamIndividualDetails && smamIndividualDetails.length > 0 ? (
                  smamIndividualDetails.map((item, index) => (
                    <>
                      <tr key={index}>
                        <td>{index + 1}</td>
                       
                        <td>{item.individual_SMAM || 0}</td>
                        <td>
                          <span 
                            role="button"
                            onClick={() => handleSMAMIndToggle(index, item)}
                            style={{
                              cursor: "pointer",
                              color: "#0d6efd",
                              fontSize: "12px",
                              fontWeight: "bold"
                            }}
                            title="Click for more details"
                          >
                            {expandedSMAMIndex === index ? "-" : "+"}
                          </span>
                        </td>
                      </tr>
                      {expandedSMAMIndex === index && (
                        <tr>
                          <td colSpan={4} className="p-0">
                            <div className="d-flex justify-content-between align-items-center mb-2 p-2">
                              <h5 className="mb-0">District Details for {item.stateName}</h5>
                              <button 
                                className="btn btn-sm btn-outline-success" 
                                onClick={() => exportToCSV(smamChcDetailedData[index] || [], `State_SMAM_CHC_Districts_${item.stateName}`, ["S.No", "District", "User Count"])}
                              >
                                Export CSV
                              </button>
                            </div>
                            <div className="table-responsive">
                              <table className="table table-bordered m-0">
                                <thead>
                                  <tr className="table-light">
                                    <th>Sr. No.</th>
                                    <th>District Name</th>
                                    <th>User Count</th>
                                    {/* <tH>Action</tH> */}
                                  </tr>
                                </thead>
                                <tbody>
                                  {smamChcDetailedData[index]?.length > 0 ? (
                                    smamChcDetailedData[index].map((detail, detailIdx) => (
                                      <>
                                        <tr key={detailIdx}>
                                          <td>{detailIdx + 1}</td>
                                          <td>{detail.districtNames}</td>
                                          <td>{detail.total || 0}</td>
                                          {/* <td>
                                            <span 
                                              role="button"
                                              onClick={() => handleDistrictDrillDown(detail.districtCode, detail.districtNames)}
                                              style={{
                                                cursor: "pointer",
                                                color: "#0d6efd",
                                                fontSize: "12px",
                                                fontWeight: "bold"
                                              }}
                                              title="Click for district details"
                                            >
                                              {selectedDistrict === detail.districtCode ? "-" : "+"}
                                            </span>
                                          </td> */}
                                        </tr>
                                        {selectedDistrict === detail.districtCode && districtDrillDownData[detail.districtCode] && (
                                          <tr>
                                            <td colSpan={4}>
                                              <div className="ms-4">
                                                <div className="d-flex justify-content-between align-items-center mb-2">
                                                  <h5 className="mb-0">Surveyor Details for {districtDrillDownData[detail.districtCode].name}</h5>
                                                  <button 
                                                    className="btn btn-sm btn-outline-success" 
                                                    onClick={() => exportToCSV(
                                                      districtDrillDownData[detail.districtCode].data,
                                                      `District_Surveyors_${districtDrillDownData[detail.districtCode].name}`,
                                                      ["S.No", "Surveyor Name", "Mobile", "Email"]
                                                    )}
                                                  >
                                                    Export CSV
                                                  </button>
                                                </div>
                                                <table className="table table-bordered">
                                                  <thead>
                                                    <tr>
                                                      <th>Sr. No.</th>
                                                      <th>Surveyor Name</th>
                                                      <th>District Name</th>
                                                      <th>Action</th>
                                                    </tr>
                                                  </thead>
                                                  <tbody>
                                                    {districtDrillDownData[detail.districtCode].data.length > 0 ? (
                                                      districtDrillDownData[detail.districtCode].data.map((surveyor, idx) => (
                                                        <tr key={idx}>
                                                          <td>{idx + 1}</td>
                                                         
                                                          <td>{surveyor.surveyorName || surveyor.userName || 'N/A'}</td>
                                                          <td>{surveyor.districtName}</td>
                                                          <td>
                                                            <span 
                                                              role="button"
                                                               onClick={() => handleSurveyorDrillDown(surveyor.surveyorName, surveyor.districtName, surveyor.userCode || surveyor.id)}
                                                              style={{
                                                                cursor: "pointer",
                                                                color: "#0d6efd",
                                                                fontSize: "12px",
                                                                fontWeight: "bold"
                                                              }}
                                                            >
                                                              {selectedSurveyor === surveyor.surveyorName ? "-" : "+"}
                                                            </span>
                                                          </td>
                                                        </tr>
                                                      ))
                                                    ) : (
                                                      <tr>
                                                        <td colSpan={4} className="text-center">No surveyor data available</td>
                                                      </tr>
                                                    )}
                                                  </tbody>
                                                </table>
                                              </div>
                                            </td>
                                          </tr>
                                        )}
                                      </>
                                    ))
                                  ) : (
                                    <tr>
                                      <td colSpan={3} className="text-center">
                                        {localLoading ? 'Loading...' : 'No detailed data available'}
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </td>
                        </tr>
                      )}
                    </>
                  ))
                ) : (
                  <tr>
                    <td colSpan={4} className="text-center">No Individual SMAM survey data available</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}


      {/* CRM CHC Survey Details Table - Only show for CRM Component */}
      {isCRMComponent && activeTable === 'crmChc' && (
        <div className="col-12">
          <h5>CRM CHC Survey Details</h5>
          <div className="d-flex justify-content-end mb-2">
            <button 
              className="btn btn-success" 
              onClick={() => exportToCSV(crmChcDetails, "CRM_CHC_Survey_Report", ["S.No", "State", "Count"])}
            >
              Export CSV
            </button>
          </div>
          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr className="table-light">
                  <th>Sr. No.</th>
                  <th>State</th>
                  <th>Count</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {crmChcDetails && crmChcDetails.length > 0 ? (
                  crmChcDetails.map((item, index) => (
                    <>
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{item.stateName || 'N/A'}</td>
                        <td>{item.total || 0}</td>
                        <td>
                          <span 
                            role="button"
                            onClick={() => handleCRMCHCToggle(index, item)}
                            style={{
                              cursor: "pointer",
                              color: "#0d6efd",
                              fontSize: "12px",
                              fontWeight: "bold"
                            }}
                            title="Click for more details"
                          >
                            {expandedCRMIndex === index ? "-" : "+"}
                          </span>
                        </td>
                      </tr>
                      {expandedCRMIndex === index && (
                        <tr>
                          <td colSpan={4} className="p-0">
                            <div className="d-flex justify-content-between align-items-center mb-2 p-2">
                              <h5 className="mb-0">District Details for {item.stateName}</h5>
                              <button 
                                className="btn btn-sm btn-outline-success" 
                                onClick={() => exportToCSV(crmChcDetailedData[index] || [], `State_CRM_CHC_Districts_${item.stateName}`, ["S.No", "District", "User Count"])}
                              >
                                Export CSV
                              </button>
                            </div>
                            <div className="table-responsive">
                              <table className="table table-bordered m-0">
                                <thead>
                                  <tr className="table-light">
                                    <th>Sr. No.</th>
                                    <th>District</th>
                                    <th>Count</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {crmChcDetailedData[index]?.length > 0 ? (
                                    crmChcDetailedData[index].map((detail, detailIdx) => (
                                      <tr key={detailIdx}>
                                        <td>{detailIdx + 1}</td>
                                        <td>{detail.districtNames}</td>
                                        <td>{detail.total || 0}</td>
                                      </tr>
                                    ))
                                  ) : (
                                    <tr>
                                      <td colSpan={3} className="text-center">
                                        {localLoading ? 'Loading...' : 'No detailed data available'}
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </td>
                        </tr>
                      )}
                    </>
                  ))
                ) : (
                  <tr>
                    <td colSpan={4} className="text-center">No CRM CHC survey data available</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* Active Users Details Table */}
      {activeTable === 'user' && (
        <div className="col-12">
          <h5>Active Users Details</h5>
          <div className="d-flex justify-content-end mb-2">
            <button 
              className="btn btn-success" 
              onClick={() => exportToCSV(stateDetails, "Active_Users_Report", ["S.No", "User Type", "User Count"])}
            >
              Export CSV
            </button>
          </div>
          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr className="table-light">
                  <th>Sr. No.</th>
                  <th>User Type</th>
                  <th>User Count</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {stateDetails && stateDetails.length > 0 ? (
                  stateDetails.map((user, index) => (
                    <React.Fragment key={index}>
                      <tr>
                        <td>{index + 1}</td>
                        <td>{user.userTypeName}</td>
                        <td>{user.totalUsers}</td>
                        <td>
                          <span 
                            role="button"
                            onClick={() => handleUserTypeToggle(index, user.userTypeName)}
                            style={{
                              cursor: "pointer",
                              color: "#0d6efd",
                              fontSize: "16px",
                              fontWeight: "bold"
                            }}
                          >
                            {expandedUserTypeIndex === index ? "-" : "+"}
                          </span>
                        </td>
                      </tr>
                      {expandedUserTypeIndex === index && stateData.length > 0 && (
                        <tr>
                          <td colSpan={4}>
                            <div className="ms-4">
                              <table className="table table-bordered">
                                <thead>
                                  <tr>
                                    <th>Sr. No.</th>
                                    <th>State</th>
                                    <th>User Count</th>
                                    <th>Action</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {stateData.map((state, stateIdx) => (
                                    <React.Fragment key={stateIdx}>
                                      <tr>
                                        <td>{stateIdx + 1}</td>
                                        <td>{user.userTypeName === "SMAM" ? state.stateName : state.category}</td>
                                        <td>{state.totalUsers}</td>
                                        <td>
                                          <span 
                                            role="button"
                                            onClick={() => handleStateToggle(stateIdx, state, user.userTypeName)}
                                            style={{
                                              cursor: "pointer",
                                              color: "#0d6efd",
                                              fontSize: "16px",
                                              fontWeight: "bold"
                                            }}
                                          >
                                            {expandedStateIndex === stateIdx ? "-" : "+"}
                                          </span>
                                        </td>
                                      </tr>
                                      {expandedStateIndex === stateIdx && districtData.length > 0 && (
                                        <tr>
                                          <td colSpan={4}>
                                            <div className="ms-4">
                                              <div className="d-flex justify-content-between align-items-center mb-2">
                                                <h5 className="mb-0">District Details for {user.userTypeName === "SMAM" ? state.stateName : state.category}</h5>
                                                <button 
                                                  className="btn btn-sm btn-outline-success" 
                                                  onClick={() => exportToCSV(districtData, `State_Active_Users_Districts_${user.userTypeName === "SMAM" ? state.stateName : state.category}`, ["S.No", "District", "User Count"])}
                                                >
                                                  Export CSV
                                                </button>
                                              </div>
                                              <table className="table table-bordered">
                                                <thead>
                                                  <tr>
                                                    <th>Sr. No.</th>
                                                    <th>District</th>
                                                    <th>User Count</th>
                                                    {/* <th>Action</th> */}
                                                  </tr>
                                                </thead>
                                                <tbody>
                                                  {districtData.map((district, districtIdx) => (
                                                    <React.Fragment key={districtIdx}>
                                                      <tr>
                                                        <td>{districtIdx + 1}</td>
                                                        <td>{district.districtNames}</td>
                                                        <td>{district.totalUsers}</td>
                                                        {/* <td>
                                                          <span 
                                                            role="button"
                                                            onClick={() => handleDistrictToggle(districtIdx, district, user.userTypeName)}
                                                            style={{
                                                              cursor: "pointer",
                                                              color: "#0d6efd",
                                                              fontSize: "16px",
                                                              fontWeight: "bold"
                                                            }}
                                                          >
                                                            {expandedDistrictIndex === districtIdx ? "-" : "+"}
                                                          </span>
                                                        </td> */}
                                                      </tr>
                                                      {expandedDistrictIndex === districtIdx && surveyorData.length > 0 && (
                                                        <tr>
                                                          <td colSpan={4}>
                                                            <div className="ms-4">
                                                              <div className="d-flex justify-content-between align-items-center mb-2">
                                                                <h5 className="mb-0">Surveyor Details for {district.districtNames}</h5>
                                                                <button 
                                                                  className="btn btn-sm btn-outline-success" 
                                                                  onClick={() => exportToCSV(surveyorData, `Surveyor_Details_${district.districtNames}`, ["S.No", "Surveyor Name", "Mobile", "Total Farmers"])}
                                                                >
                                                                  Export CSV
                                                                </button>
                                                              </div>
                                                              <table className="table table-bordered table-sm">
                                                                <thead>
                                                                  <tr>
                                                                    <th>Sr. No.</th>
                                                                    <th>Surveyor Name</th>
                                                                    <th>District Name</th>
                                                                    <th>Action</th>
                                                                  </tr>
                                                                </thead>
                                                                <tbody>
                                                                  {surveyorData.map((surveyor, surveyorIdx) => {
                                                                    const surveyorKey = `surveyor-${surveyorIdx}`;
                                                                    return (
                                                                      <tr key={surveyorIdx}>
                                                                        <td>{surveyorIdx + 1}</td>
                                                                        <td>{surveyor.surveyorName || surveyor.userName || 'N/A'}</td>
                                                                        <td>{surveyor.districtName}</td>
                                                                        <td>
                                                                          <button 
                                                                            className="btn btn-sm btn-warning me-1" 
                                                                            type="button" 
                                                                            onClick={() => toggleSurveyorExpansion(surveyor, surveyorKey)}
                                                                            title={isSurveyorExpanded ? "Collapse Farmers" : "Expand Farmers"}
                                                                            disabled={loadingFarmers[surveyorKey]}
                                                                          >
                                                                            {loadingFarmers[surveyorKey] ? (
                                                                              <i className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></i>
                                                                            ) : (
                                                                              <i><FontAwesomeIcon icon={isSurveyorExpanded ? faMinus : faPlus} /></i>
                                                                            )}
                                                                          </button>
                                                                        </td>
                                                                      </tr>
                                                                      
                                                                    );
                                                                  })}
                                                                </tbody>
                                                              </table>
                                                            </div>
                                                          </td>
                                                        </tr>
                                                      )}
                                                    </React.Fragment>
                                                  ))}
                                                </tbody>
                                              </table>
                                            </div>
                                          </td>
                                        </tr>
                                      )}
                                    </React.Fragment>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  ))
                  ) : (
                    <tr>
                      <td colSpan={4} className="text-center">No State details available</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
      )}
      {/* API Data Report Details Table */}
      {activeTable === 'apiDataReport' && isCRMComponent && (
        <div className="col-12" id="api-data-report-table">
          <div className="card">
            <div className="card-body">
              <h5 className="card-title">API Data Report Details</h5>
              <div className="d-flex justify-content-between align-items-center mb-2">
                <div className="d-flex align-items-center">
                  <label htmlFor="finYearSelect" className="me-2 mb-0">Financial Year:</label>
                  <select 
                    id="finYearSelect"
                    className="form-select form-select-sm" 
                    style={{ width: "200px" }}
                    value={selectedFinYear}
                    onChange={handleFinYearChange}
                  >
                    <option value="">All Years</option>
                    <option value="2020-21">2020-21</option>
                    <option value="2021-22">2021-22</option>
                    <option value="2022-23">2022-23</option>
                    <option value="2023-24">2023-24</option>
                    <option value="2024-25">2024-25</option>
                    <option value="2025-26">2025-26</option>
                  </select>
                </div>
                <button 
                  className="btn btn-sm btn-success" 
                  onClick={() => exportToCSV(apiDataReportDetails, "MT_API_Data_Report", ["S.No", "District Name", "Record Count"])}
                >
                  Export CSV
                </button>
              </div>
              <div className="table-responsive">
                <table className="table table-striped">
                  <thead>
                    <tr>
                      <th>Sr. No.</th>
                      <th>District Name</th>
                      <th>Total</th>
                      <th>View Details</th>
                    </tr>
                  </thead>
                  <tbody>
                    {apiDataReportDetails && apiDataReportDetails.length > 0 ? (
                      apiDataReportDetails.map((report, index) => (
                        <React.Fragment key={report.districtCode || index}>
                          <tr>
                            <td>{index + 1}</td>
                            <td>{report.districtName || 'N/A'}</td>
                            <td>{report.recordCount || 0}</td>
                            <td>
                              <span 
                                role="button"
                                onClick={() => handleApiDataReportToggle(index, report)}
                                style={{
                                  cursor: "pointer",
                                  color: "#0d6efd",
                                  fontSize: "16px",
                                  fontWeight: "bold"
                                }}
                              >
                                {expandedApiDataReportIndex === index ? "-" : "+"}
                              </span>
                            </td>
                          </tr>
                          {expandedApiDataReportIndex === index && expandedApiDataReportDistrictData.length > 0 && (
                            <tr>
                              <td colSpan={4}>
                                <div className="ms-4 mt-2">
                                  <div className="d-flex justify-content-between align-items-center mb-2">
                                    <h5 className="mb-0">Sub District Details for {report.districtName}</h5>
                                    <button 
                                      className="btn btn-sm btn-outline-success" 
                                      onClick={() => exportToCSV(expandedApiDataReportDistrictData, `MT_API_Data_Report_SubDistricts_${report.districtName}`, ["S.No", "Sub District Name", "Record Count"])}
                                    >
                                      Export CSV
                                    </button>
                                  </div>
                                  <table className="table table-sm table-bordered mb-0">
                                    <thead>
                                      <tr>
                                        <th>Sr. No.</th>
                                        <th>Sub District Name</th>
                                        <th>Record Count</th>
                                        <th>View Details</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {expandedApiDataReportDistrictData.map((block, bIndex) => (
                                        <React.Fragment key={block.blockCode || bIndex}>
                                          <tr>
                                            <td>{bIndex + 1}</td>
                                            <td>{block.blockName || 'N/A'}</td>
                                            <td>{block.recordCount || 0}</td>
                                            <td>
                                              <span
                                                role="button"
                                                onClick={() => handleApiDataSubDistrictReportToggle(bIndex, block, report)}
                                                style={{
                                                  cursor: "pointer",
                                                  color: "#198754",
                                                  fontSize: "16px",
                                                  fontWeight: "bold"
                                                }}
                                              >
                                                {expandedApiDataReportSubDistrictIndex === bIndex ? "-" : "+"}
                                              </span>
                                            </td>
                                          </tr>
                                          {expandedApiDataReportSubDistrictIndex === bIndex && expandedApiDataReportSubDistrictDetailsData.length > 0 && (
                                            <tr>
                                              <td colSpan={4}>
                                                <div className="ms-4 mt-2">
                                                  <div className="d-flex justify-content-between align-items-center mb-2">
                                                    <h5 className="mb-0">CHC Details for {block.blockName}</h5>
                                                    <button 
                                                      className="btn btn-sm btn-outline-success" 
                                                      onClick={() => exportToCSV(expandedApiDataReportSubDistrictDetailsData, `MT_API_Data_Report_CHC_${block.blockName}`, ["S.No", "CHC Name", "Village Name", "Record Count"])}
                                                    >
                                                      Export CSV
                                                    </button>
                                                  </div>
                                                  <table className="table table-sm table-bordered mb-0">
                                                    <thead>
                                                      <tr>
                                                        <th>Sr. No.</th>
                                                        <th>CHC Name</th>
                                                        <th>Address</th>
                                                        <th>Registration No.</th>
                                                        <th>Mobile No.</th>
                                                        <th>Image</th>
                                                        <th>No of Implement</th>
                                                      </tr>
                                                    </thead>
                                                    <tbody>
                                                      {expandedApiDataReportSubDistrictDetailsData.map((chc, cIndex) => (
                                                        <tr key={chc.id || cIndex}>
                                                          <td>{cIndex + 1}</td>
                                                          <td>{chc.chcName}</td>
                                                          <td>{chc.landMarkAddress}</td>
                                                          <td>{chc.societyRegistrationNumber}</td>
                                                          <td>{chc.mobileNo}</td>
                                                          <td>
                                                            {chc.imagePath ? (
                                                              <FontAwesomeIcon
                                                                icon={faEye}
                                                                onClick={() => handleImageView(chc.imagePath)}
                                                                style={{
                                                                  cursor: "pointer",
                                                                  color: "#198754",
                                                                  fontSize: "18px"
                                                                }}
                                                                title="View Image"
                                                              />
                                                            ) : (
                                                              <span style={{ color: "#999" }}>N/A</span>
                                                            )}
                                                          </td>
                                                          <td>
                                                            {chc.noOfImplements > 0 ? (
                                                              <span
                                                                onClick={() => handleImplementsClick(chc)}
                                                                style={{
                                                                  cursor: "pointer",
                                                                  color: "#0066cc",
                                                                  textDecoration: "underline"
                                                                }}
                                                                title="Click to view implement details"
                                                              >
                                                                {chc.noOfImplements}
                                                              </span>
                                                            ) : (
                                                              <span style={{ color: "#999" }}>0</span>
                                                            )}
                                                          </td>
                                                        </tr>
                                                      ))}
                                                    </tbody>
                                                  </table>
                                                </div>
                                              </td>
                                            </tr>
                                          )}
                                        </React.Fragment>
                                      ))}
                                    </tbody>
                                  </table>
                                </div>
                              </td>
                            </tr>
                          )}
                        </React.Fragment>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={4} className="text-center">No data available</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Image Modal */}
      {showImageModal && selectedImageUrl && (
        <div
          className="modal fade show"
          style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}
          tabIndex="-1"
          aria-labelledby="imageModalLabel"
          aria-hidden="false"
          onClick={handleCloseImageModal}
        >
          <div 
            className="modal-dialog modal-lg modal-dialog-centered"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="imageModalLabel">
                  CHC Image
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={handleCloseImageModal}
                  aria-label="Close"
                >x</button>
              </div>
              <div className="modal-body text-center">
                <img
                  src={selectedImageUrl}
                  alt="CHC Image"
                  className="img-fluid"
                  style={{ maxHeight: '70vh' }}
                  onError={(e) => {
                    console.error('Image failed to load:', e.target.src);
                    e.target.style.display = 'none';
                    e.target.parentElement.innerHTML = '<p class="text-danger">Failed to load image</p>';
                  }}
                />
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={handleCloseImageModal}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Implement Details Modal */}
      {showImplementsModal && selectedImplements && (
        <div
          className="modal fade show"
          style={{ display: 'block', backgroundColor: 'rgba(193, 183, 183, 0)' }}
          tabIndex="-1"
          aria-labelledby="implementModalLabel"
          aria-hidden="false"
          onClick={handleCloseImplementsModal}
        >
          <div 
            className="modal-dialog modal-lg modal-dialog-centered"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-content">
              <div className="modal-header" style={{ backgroundColor: '#c9ebc9', borderBottom: '0px solid #dee2e6' }}>
                <h5 className="modal-title" id="implementModalLabel" style={{ fontWeight: 'bold' }}>
                  Implement Details
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={handleCloseImplementsModal}
                  aria-label="Close"
                >x</button>
              </div>
              <div className="modal-body">
                <div className="mb-3">
                  <p><strong>CHC Name:</strong> {selectedImplements.chcName}; <strong>Total Implements:</strong> {selectedImplements.noOfImplements}</p>
                </div>
                <div className="table-responsive">
                  <table className="table table-bordered table-striped">
                    <thead className="table-light123">
                      <tr>
                        <th style={{ width: '10%' }}>S.No</th>
                        <th style={{ width: '45%' }}>Category Name</th>
                        <th style={{ width: '45%' }}>Implement Name</th>
                      </tr>
                    </thead>
                    <tbody>
                      {(() => {
                        try {
                          const implementDetails = selectedImplements.implementDetailsJSON 
                            ? JSON.parse(selectedImplements.implementDetailsJSON) 
                            : [];
                          
                          if (implementDetails.length === 0) {
                            return (
                              <tr>
                                <td colSpan="3" className="text-center">No implement details available</td>
                              </tr>
                            );
                          }
                          
                          return implementDetails.map((item, index) => {
                            // Parse ImplementSubsidyName to extract Implement Name and Category Name
                            let implementName = 'N/A';
                            let categoryName = 'N/A';
                            
                            if (item.ImplementSubsidyName) {
                              const parts = item.ImplementSubsidyName.split(' - ');
                              if (parts.length === 2) {
                                implementName = parts[0].trim();
                                categoryName = parts[1].trim();
                              } else {
                                // If format is different, use the whole string as implement name
                                implementName = item.ImplementSubsidyName;
                              }
                            } else if (item.ImplementName && item.CategoryName) {
                              // Fallback to direct fields if available
                              implementName = item.ImplementName;
                              categoryName = item.CategoryName;
                            }
                            
                            return (
                              <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{categoryName}</td>
                                <td>{implementName}</td>
                              </tr>
                            );
                          });
                        } catch (error) {
                          console.error('Error parsing implement details:', error);
                          return (
                            <tr>
                              <td colSpan="3" className="text-center text-danger">Error loading implement details</td>
                            </tr>
                          );
                        }
                      })()}
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="modal-footer" style={{ backgroundColor: '#c9ebc9', borderTop: '1px solid #dee2e6' }}>
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={handleCloseImplementsModal}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default StateLoginDashboard;
